module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-bag.ebc9b872.svg";